import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ProjectList } from '../helpers/ProjectList';
import '../styles/ProjectDisplay.css';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from "react-router-dom";

function ProjectDisplay() {
  const { id } = useParams();

  const project = ProjectList[id];

  const slides = project.images.map(image => {
    return image;
  });

  const navigate = useNavigate();

  const [model, setModel] = useState(false);
  const [tempimgSrc, setTempImgSrc] = useState('');

  const getImg = (slide) => {
    setTempImgSrc(slide);
    setModel(true);
  }

  return (
    <div className='project-wrapper'>
      <div className="back-button-wrapper">
        <button onClick={() => {
            navigate("/projects/");
          }}><i class="fa-solid fa-arrow-left"></i></button>
      </div>
      <div className='project'>
        <div className='project-info'>
          <h1>{project.name}</h1>
          <h3>{project.subtitle}</h3>
          <h3>{project.date}</h3>
          <h3>Client: {project.client}</h3>
          <p>{project.description}</p>
          <p>{project.description2}</p>
        </div>
        <div className={model ? "model open" : "model"}>
          <img src={tempimgSrc} alt=''/>
          <CloseIcon onClick={() =>setModel(false)}/>
        </div>
        <div className='gallery'>
          {slides.map((slide, index) => (
            <div className='pics' key={index} onClick={()=>getImg(slide)}>
              <img src={slide} style={{width: '100%'}} alt='' loading="lazy"/>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProjectDisplay;
